export const PIXEL_AVATAR_STORAGE_KEY = "arcadePixelAvatar";

export const MIN_GRID = 2;
export const MAX_GRID = 128;
export const DEFAULT_GRID = 9;

export const emptyGrid = (size) =>
  Array.from({ length: size * size }, () => null);

export const clampGridSize = (value) => {
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed)) return null;
  return Math.min(MAX_GRID, Math.max(MIN_GRID, parsed));
};

export const normalizeHex = (value) => {
  const raw = String(value || "").trim();
  const withHash = raw.startsWith("#") ? raw : `#${raw}`;
  if (/^#[0-9a-fA-F]{6}$/.test(withHash)) {
    return withHash.toUpperCase();
  }
  return null;
};

export const serializePixelAvatar = ({
  gridSize,
  mode,
  color,
  pixels,
  gridHidden = false,
}) => {
  const size = clampGridSize(gridSize);
  if (!size || !Array.isArray(pixels)) return null;
  const cells = [];
  const limit = size * size;
  for (let index = 0; index < Math.min(pixels.length, limit); index += 1) {
    const hex = normalizeHex(pixels[index]);
    if (!hex) continue;
    cells.push(`${index}:${hex.slice(1)}`);
  }
  return {
    v: 1,
    gridSize: size,
    mode: mode === "advanced" ? "advanced" : "simple",
    color: normalizeHex(color) || "#F4D35E",
    gridHidden: Boolean(gridHidden),
    cells: cells.join(","),
  };
};

export const deserializePixelAvatar = (raw) => {
  if (!raw || typeof raw !== "object") return null;
  const gridSize = clampGridSize(raw.gridSize);
  if (!gridSize) return null;
  const pixels = emptyGrid(gridSize);
  const packed = String(raw.cells || "");
  if (packed) {
    packed.split(",").forEach((part) => {
      const splitAt = part.indexOf(":");
      if (splitAt <= 0) return;
      const index = parseInt(part.slice(0, splitAt), 10);
      const hex = normalizeHex(part.slice(splitAt + 1));
      if (
        !Number.isInteger(index) ||
        index < 0 ||
        index >= pixels.length ||
        !hex
      ) {
        return;
      }
      pixels[index] = hex;
    });
  }
  return {
    gridSize,
    mode: raw.mode === "advanced" ? "advanced" : "simple",
    color: normalizeHex(raw.color) || "#F4D35E",
    gridHidden: Boolean(raw.gridHidden),
    pixels,
  };
};

export const readLocalPixelAvatar = () => {
  try {
    if (typeof window === "undefined" || !window.localStorage) return null;
    const raw = window.localStorage.getItem(PIXEL_AVATAR_STORAGE_KEY);
    if (!raw) return null;
    return deserializePixelAvatar(JSON.parse(raw));
  } catch {
    return null;
  }
};
